import React from 'react';

import AccountMenuNav3 from '@atlassian/account-menu';

import { AccountInternal, type AccountProps } from './index';

export const AccountNav3: React.ComponentType<AccountProps> = (props) => {
	return <AccountInternal {...props} AccountMenu={AccountMenuNav3} />;
};
